import { StateCreator } from 'zustand';

import {
  handleApplyGeneratedDraft,
  handleApplyRevision,
  handleBackToOptions,
  handleEditBody,
  handleEnterChat,
  handleEnterReply,
  handleMarkError,
  handleMarkSending,
  handleMarkSent,
  handleSetDraftGenerating,
  handleSetRecipients,
} from './handlers';
import {
  ApplyGeneratedDraftParams,
  ApplyRevisionParams,
  DoBoxReplyPanelState,
  DoBoxReplyPanelStore,
  EnterReplyParams,
  HandlerSet,
  MarkSentParams,
  ReplyDraft,
} from './types';

export const INITIAL_DOBOX_REPLY_PANEL_STATE: DoBoxReplyPanelState = {
  modeByItemId: {},
  draftsByKey: {},
  activeReply: null,
  lastSent: null,
};

export const createDoBoxReplyPanelSlice: StateCreator<DoBoxReplyPanelStore> = (
  set,
) => {
  const handlerSet: HandlerSet = (updater) => {
    if (typeof updater === 'function') {
      set((fullState) => updater(fullState) as Partial<DoBoxReplyPanelStore>);
    } else {
      set(updater as Partial<DoBoxReplyPanelStore>);
    }
  };

  return {
    ...INITIAL_DOBOX_REPLY_PANEL_STATE,

    enterReply: (params: EnterReplyParams) =>
      handleEnterReply(handlerSet, params),
    backToOptions: (itemId: string) => handleBackToOptions(handlerSet, itemId),
    enterChat: (itemId: string) => handleEnterChat(handlerSet, itemId),
    setDraftGenerating: (itemId: string, messageId: string) =>
      handleSetDraftGenerating(handlerSet, itemId, messageId),
    applyGeneratedDraft: (
      itemId: string,
      messageId: string,
      draft: ApplyGeneratedDraftParams,
    ) => handleApplyGeneratedDraft(handlerSet, itemId, messageId, draft),
    applyRevision: (
      itemId: string,
      messageId: string,
      revision: ApplyRevisionParams,
    ) => handleApplyRevision(handlerSet, itemId, messageId, revision),
    editBody: (itemId: string, messageId: string, body: string) =>
      handleEditBody(handlerSet, itemId, messageId, body),
    setRecipients: (
      itemId: string,
      messageId: string,
      recipients: { to: ReplyDraft['to']; cc: ReplyDraft['cc'] },
    ) => handleSetRecipients(handlerSet, itemId, messageId, recipients),
    markSending: (itemId: string, messageId: string) =>
      handleMarkSending(handlerSet, itemId, messageId),
    markSent: (itemId: string, messageId: string, receipt: MarkSentParams) =>
      handleMarkSent(handlerSet, itemId, messageId, receipt),
    markError: (itemId: string, messageId: string) =>
      handleMarkError(handlerSet, itemId, messageId),
    reset: () => set(INITIAL_DOBOX_REPLY_PANEL_STATE),
  };
};
